(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/pages/self-exclusion-main.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/pages/self-exclusion-main.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const _jotai = jotai,
  useAtom = _jotai.useAtom;
const _svs$selfExclusion$st = svs.selfExclusion.store.selfExclusionAtoms,
  activeExclusionsAtom = _svs$selfExclusion$st.activeExclusionsAtom,
  isNaExcludedAtom = _svs$selfExclusion$st.isNaExcludedAtom;
const _svs$selfExclusion$co = svs.selfExclusion.components,
  SelfExclusion24 = _svs$selfExclusion$co.SelfExclusion24,
  SetSelfExclusion = _svs$selfExclusion$co.SetSelfExclusion,
  NationalSelfExclusion = _svs$selfExclusion$co.NationalSelfExclusion,
  Information = _svs$selfExclusion$co.Information,
  ActiveExclusions = _svs$selfExclusion$co.ActiveExclusions,
  GamePauseInfo = _svs$selfExclusion$co.GamePauseInfo,
  SelfExclusion24AbTest = _svs$selfExclusion$co.SelfExclusion24AbTest,
  SetSelfExclusionAbTest = _svs$selfExclusion$co.SetSelfExclusionAbTest,
  NationalSelfExclusionAbTest = _svs$selfExclusion$co.NationalSelfExclusionAbTest,
  InformationAbTest = _svs$selfExclusion$co.InformationAbTest,
  ActiveExclusionsAbTest = _svs$selfExclusion$co.ActiveExclusionsAbTest;
const SelfExclusionMain = () => {
  var _svs$core$config$data;
  const _useAtom = useAtom(activeExclusionsAtom),
    _useAtom2 = _slicedToArray(_useAtom, 1),
    exclusions = _useAtom2[0];
  const _useAtom3 = useAtom(isNaExcludedAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 1),
    naExcluded = _useAtom4[0];
  const hasExclusions = exclusions.length > 0 || naExcluded;
  const isPnp = ((_svs$core$config$data = svs.core.config.data) === null || _svs$core$config$data === void 0 || (_svs$core$config$data = _svs$core$config$data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.site) === 'momang';
  const isInTarget = svs.components.targeting.isTargeted('self_exclusion_design', 'B') && !isPnp;
  if (isInTarget) {
    return React.createElement("main", {
      id: "self-exclusion-overview"
    }, React.createElement("h2", {
      className: "align-center font-weight-700"
    }, "Spelpaus"), React.createElement("p", {
      className: "align-center"
    }, "V\xE4lj sj\xE4lv vad du vill ta en paus fr\xE5n och hur l\xE5ng pausen ska vara."), React.createElement(Grid, null, React.createElement(GridRow, {
      className: "padding-xs-h-1",
      md: {
        gutter: 3
      },
      xs: {
        gutter: 3
      }
    }, React.createElement(GridCol, {
      am: 8,
      xs: 12
    }, hasExclusions && React.createElement(ActiveExclusionsAbTest, {
      exclusions: exclusions,
      naExcluded: naExcluded
    }), React.createElement(NationalSelfExclusionAbTest, null), React.createElement(SetSelfExclusionAbTest, null), React.createElement(SelfExclusion24AbTest, null), React.createElement(InformationAbTest, null)), React.createElement(GridCol, {
      am: 4,
      xs: 12
    }, React.createElement(GamePauseInfo, null)))));
  }
  return React.createElement("main", {
    id: "self-exclusion-overview"
  }, hasExclusions && React.createElement(ActiveExclusions, {
    exclusions: exclusions,
    naExcluded: naExcluded
  }), React.createElement(SelfExclusion24, null), React.createElement(SetSelfExclusion, null), React.createElement(NationalSelfExclusion, null), React.createElement(Information, null));
};
svs.selfExclusion.components.SelfExclusionMain = SelfExclusionMain;

 })(window);